// extracted by mini-css-extract-plugin
export default {"title":"c_j","chart-navigation":"c_k","chart-navigation__left":"c_l","chart-navigation__right":"c_m"};